import { render, staticRenderFns } from "./ContentEditableField.vue?vue&type=template&id=2312ade8&scoped=true"
import script from "./ContentEditableField.vue?vue&type=script&lang=ts"
export * from "./ContentEditableField.vue?vue&type=script&lang=ts"
import style0 from "./ContentEditableField.vue?vue&type=style&index=0&id=2312ade8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2312ade8",
  null
  
)

export default component.exports